<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            v-if="data.length > 0"
            id="exportBtn"
            icon-pack="feather"
            icon="icon-file-text"
            color="success"
            type="border"
            class="mb-4 md:mb-0 vs-con-loading__container"
            @click="exportReport"
            >Export All</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th>Date</th>
              <th>Type</th>
              <th>Changed By</th>
              <th>Old Imei</th>
              <th>New Imei</th>
              <th>Device Name</th>
              <th>GSM No</th>
              <th>Owner</th>
              <th>Description</th>
              <th>Type</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="15" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td>{{ item.created_at }}</td>
              <td>{{ item.type == 0 ? 'Warranty Claim' : 'Trade In' }}</td>
              <td>{{ item.change_by }}</td>
              <td>{{ item.old_imei }}</td>
              <td>{{ item.new_imei }}</td>
              <td>{{ item.device_name }}</td>
              <td>{{ item.gsm_no }}</td>
              <td>{{ item.owner }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.type == 1 ? 'Trade In' : 'Warranty Claim' }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="15" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

      <vs-popup
        classContent="popup-example"
        title="Export History Change Unit"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <label class="vs-input--label">Start Time</label>
              <!-- <flat-pickr :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }" style="width: 100%" v-model="filter.start"/> -->
              <datetime
                v-model="filter.start"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
              ></datetime>
            </div>
            <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
              <label class="vs-input--label">End Time</label>
              <datetime
                v-model="filter.end"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
              ></datetime>
              <!-- <flat-pickr :config="{ enableTime: true, dateFormat: 'Y-m-d H:i' }" style="width: 100%" v-model="filter.end" /> -->
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="downloadBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="download"
                >Export</vs-button
              >
              <vs-button
                color="warning"
                type="border"
                @click="cancel"
                class="mb-2"
                >Cancel</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import FileDownload from 'js-file-download'

import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

export default {
  components: {
    vSelect,
    flatPickr,
    Datetime
  },

  data() {
    return {
      data: [],
      actor: {},
      token: '',
      showPopup: false,
      tempId: 0,
      loading: true,

      filter: {
        start: '',
        end: ''
      },

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      timer: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    filter: {
      handler(val) {
        this.initTable()
      },
      deep: true
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''

    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
    this.initTable()
  },

  mounted() {},

  methods: {
    reset() {
      Object.keys(this.filter).map((item) => {
        this.filter[item] = ''
      })
    },

    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    initTable() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/change_unit/datatable`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page,
            per_page: this.per_page,
            search: this.keyword
          }
        })
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    exportReport() {
      this.showPopup = true
    },

    cancel() {
      this.showPopup = false
      this.reset()
    },

    download() {
      if (this.filter.start > this.filter.end) {
        this.$vs.notify({
          title: 'Sorry',
          text: 'Start time should be smaller than end time.',
          color: 'danger',
          position: 'top-right'
        })
      } else if (
        new Date(this.filter.end).getTime() / 1000 -
          new Date(this.filter.start).getTime() / 1000 >
        604800
      ) {
        this.$vs.notify({
          title: 'Sorry',
          text: 'Report only available for 7 days.',
          color: 'danger',
          position: 'top-right'
        })
      } else {
        this.$vs.loading({
          background: 'primary',
          color: '#fff',
          container: '#downloadBtn',
          scale: 0.45
        })

        this.$http
          .get(`${this.$api.endpoint}/change_unit/export`, {
            responseType: 'blob',
            params: {
              start: this.filter.start,
              end: this.filter.end
            },

            headers: {
              Authorization: `Bearer ${this.token}`
            }
          })
          .then((res) => {
            this.$vs.loading.close(`#downloadBtn > .con-vs-loading`)

            let filename = `Change_unit${this.filter.start
              .toString()
              .substr(0, 10)}_${this.filter.end.toString().substr(0, 10)}.xlsx`
            FileDownload(res.data, filename)

            this.showPopup = false

            this.$vs.notify({
              title: 'Success',
              text: 'Report download successfully.',
              color: 'success',
              position: 'top-right'
            })
          })
          .catch((error) => {
            this.$vs.loading.close(`#downloadBtn > .con-vs-loading`)
            this.$gf.httpErrorHandler(error)
          })
      }
    }
  }
}
</script>
